import React from 'react'
import { Route } from 'react-router-dom'
import LoginPage from 'route/login-route'
import { usePromiseTracker } from "react-promise-tracker";

import { trackPromise } from 'react-promise-tracker'
import { UserContext } from 'context/user-context'


/* global API */

const PrivateRoute = ({ component: Component, ...rest }) => {
    // Ну тип запрашивается один раз, кажись норм
    const [state, handleUpdate] = React.useState('')
    const [isLogin, setIsLogin] = React.useState(false)
    const [user, setUser] = React.useState([])
    const { promiseInProgress } = usePromiseTracker();

    React.useEffect(() => {
        trackPromise(
            (async () => {
                // console.log('gigo')
                const user = await API.instance().getMe()
                if (Object.keys(user).length) {
                    setIsLogin(true)
                    setUser(user)
                }
            })()
        )
    }, [state, setIsLogin])

    return (
        !promiseInProgress &&
        <UserContext.Provider value={user}>
            <Route
                {...rest}
                render={props =>
                    isLogin ? (
                        <Component {...props} />
                    ) : (
                        <LoginPage handleUpdate={handleUpdate} />
                    )
                }
            />
        </UserContext.Provider>
    )
}

export default PrivateRoute
